import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    static targets = ['sendByEmail', 'otherModeSection', 'contactMailField'];

    connect() {
        this.toggleInvoiceMode();
    }

    toggleInvoiceMode() {
        const sendByEmail = this.isSendByEmail();

        if (this.hasOtherModeSectionTarget) {
            this.otherModeSectionTarget.hidden = sendByEmail;
            this.otherModeSectionTarget.classList.toggle('client-form__other-mode--hidden', sendByEmail);
        }

        this.updateContactMailRequired(sendByEmail);
    }

    updateContactMailRequired(required) {
        if (!this.hasContactMailFieldTarget) {
            return;
        }

        const field = this.contactMailFieldTarget;
        const input = field.querySelector('textarea, input');
        const label = field.querySelector('label.input__label');

        if (input) {
            input.required = required;
            input.setAttribute('aria-required', required ? 'true' : 'false');
        }

        if (label) {
            label.classList.toggle('required', required);
        }
    }

    isSendByEmail() {
        if (this.hasSendByEmailTarget) {
            return this.sendByEmailTarget.checked;
        }

        return this.element.dataset.clientFormSendByEmailValue === '1';
    }
}
